/* NeoUI — Web Push (VAPID) helpers. Standard PushManager flow, no
 * third-party push service. Works with the SW at /service-worker.js. */
import api from '../api/client';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const isPushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export const getPushSubscription = async () => {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error('push_not_supported');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('permission_denied');
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get('/push/vapid-public-key');
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  const json = sub.toJSON();
  await api.post('/push/subscribe', { endpoint: json.endpoint, keys: json.keys });
  return sub;
};

export const unsubscribeFromPush = async () => {
  const sub = await getPushSubscription();
  if (!sub) return false;
  const json = sub.toJSON();
  const ok = await sub.unsubscribe();
  if (ok) {
    try { await api.post('/push/unsubscribe', { endpoint: json.endpoint }); } catch (_e) { /* noop */ }
  }
  return ok;
};

export const sendTestPush = () => api.post('/push/test');
